// extracted by mini-css-extract-plugin
module.exports = {"container":"CommunityAutomationMainDiagram_container__1Vsxy","arrowDown":"CommunityAutomationMainDiagram_arrowDown__1O3E-"};